import { router } from 'expo-router';
import React from 'react';
import { View } from 'react-native';

import { AppearanceCard } from '@/components/profile/appearance-card';
import { PageLayout } from '@/components/ui/page-layout';

function goBack() {
  if (router.canGoBack()) {
    router.back();
    return;
  }
  router.replace('/(tabs)/(provider)/settings' as never);
}

/** Configurações > Aparência: claro, escuro ou igual ao aparelho. */
export default function AppearancePage() {
  return (
    <PageLayout title="Aparência" subtitle="Vale só neste aparelho." onBack={goBack}>
      <View className="w-full max-w-2xl self-center">
        <AppearanceCard />
      </View>
    </PageLayout>
  );
}
